import React from 'react';
import { Card } from '../common';
import ReportList from './ReportList';
import './ReportTab.css';

const ReportTab = () => {

  return (
    <div className="report-tab">
      <div className="report-tab__header">
        <h1>보고서 관리</h1>
        <p>AWS 리소스 보고서를 생성하고 관리할 수 있습니다.</p>
      </div>

      <div className="report-tab__content">
        <Card>
          <ReportList />
        </Card>
      </div>
    </div>
  );
};

export default ReportTab;